import { MovementDataStore } from '@skinsoft/entity';
import { reactiveVueMixin } from '@skinsoft/reactive-vue';
import { EntityFeaturedList } from '@skinsoft/ui';
import { defineComponent, Component } from 'vue';

import { toFeatured$ } from '../../serializer/featured';
import { MovementFeaturedCard } from '../movement-featured-card';

export const MovementFeaturedList = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sEntityFeaturedList: EntityFeaturedList,
    },
    props: ['targetRouteName'],
    template: require('./movement-featured-list.html'),
    data() {
        return {
            // $movementDataStore (used in the template) is a Vue.prototype global installed by
            // MovementDataStore's Vue.use(), not per-instance state, so it has no data field here
            featuredStates: MovementDataStore.featuredStates,
            sortFields: MovementDataStore.sortFields,
            serializer: toFeatured$,

            customCard: MovementFeaturedCard as Component,
            customCardProps: {
                needsToFetchFeatured: false,
            } as Object,
        }
    },
})
